import { render, staticRenderFns } from "./baseSetting.vue?vue&type=template&id=3b527f7a&scoped=true&"
import script from "./baseSetting.vue?vue&type=script&lang=js&"
export * from "./baseSetting.vue?vue&type=script&lang=js&"
import style0 from "./baseSetting.vue?vue&type=style&index=0&id=3b527f7a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b527f7a",
  null
  
)

export default component.exports